<template>
  <i-dropdown
    :isOpen="item.showOptions"
    @update:isOpen="(o) => setFilterParamOptions({name: item.name, showOptions: o})"
  >
    <template v-slot:trigger="{toggle, attrs}">
      <i-chip
          @click="toggle"
          @close="() => disableFilterParam({name: item.name})"
          v-bind="attrs">
          {{ item.label }}
      </i-chip>
    </template>

    <template v-slot:default="{close}">
      <div class="dropdown-menu dropdown-body block">
        <div class="options-hint pa1 text-sm-fix">
          This filter parameter does not provide any configuration options.
        </div>
        <div class="i-css-right">
          <button
            @click="close"
            @keydown.enter.stop.prevent="close"
            :title="LANG.close"
            class="btn i-button i-filter-clear" >{{ LANG.close }}</button>
        </div>
      </div>
    </template>
  </i-dropdown>
</template>

<script>
import { mapState } from 'vuex';
import { mapBrowserMutations } from '@/store';

export default {
  props: {
    item: Object,
  },
  computed: {
    ...mapState(['LANG']),
  },
  methods: {
    ...mapBrowserMutations([
      'disableFilterParam',
      'setFilterParamOptions',
    ]),
  },
};
</script>

<style scoped lang="scss">
  .options-hint {
    background: #f5f5f5;
    line-height: 20px;
  }
</style>
